/**
 * Oturum kullanıcısının yerel kopyası.
 *
 * BİLEREK BAĞIMLILIKSIZ bir modül: api.ts bu dosyayı, bu dosya da api.ts'i
 * import etmez. snak'ta bu ayrım döngüsel import kırmak için yapılmıştı ve
 * doğru bir karardı — burada da korunuyor.
 *
 * Buradaki kopya YALNIZCA ilk render'ı anında yapmak içindir (sayfa
 * yenilendiğinde menü boş yanıp sönmesin). Yetkinin GERÇEĞİ her zaman
 * sunucudadır ve `/auth/me` ile tazelenir; localStorage'daki kopyaya
 * güvenilerek hiçbir kapı açılmaz.
 */

import type { SessionUser } from './permissions';
import { ROLES } from './permissions';

const USER_KEY = 'centramir.user';

function isSessionUser(value: unknown): value is SessionUser {
  if (typeof value !== 'object' || value === null) return false;
  const u = value as Record<string, unknown>;
  return (
    typeof u.id === 'string' &&
    typeof u.name === 'string' &&
    typeof u.email === 'string' &&
    typeof u.role === 'string' &&
    (ROLES as readonly string[]).includes(u.role) &&
    Array.isArray(u.areas)
  );
}

export function getUser(): SessionUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return isSessionUser(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function setUser(user: SessionUser): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearUser(): void {
  localStorage.removeItem(USER_KEY);
}
